import { LoadingButton } from "@mui/lab";
import { Box, Chip, FormHelperText, Grid, Typography } from "@mui/material";
import pic from "assets/landing/deal_flow_kit.png";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import StyledOrDivider from "components/OrDivider";
import { getSource, trackEvent } from "utils/tracking";

import styles from "./styles";

interface Props {
  checkoutProBundle: () => Promise<void>;
  fetchUserLoading: boolean;
  notQualified: boolean;
  isMobileScreen: boolean;
}

const ProgramInfo = ({
  checkoutProBundle,
  fetchUserLoading,
  notQualified,
  isMobileScreen = false,
}: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { currentOrg } = useContext(OrganizationUserContext);

  const clickGo = async () => {
    if (notQualified) {
      navigate(`/${routes.home}${location.search}`);
      return;
    }
    trackEvent("Pro Bundle - Claim Offer Button Clicked", {
      source: getSource(),
    });
    if (currentOrg?.id) {
      await checkoutProBundle();
    } else {
      navigate(`/${routes.proBundleSignUp}${location.search}`);
    }
  };

  return (
    <Box sx={{ maxWidth: 700, my: 3, px: { xs: 2, md: 6, lg: 10 } }}>
      <Typography
        variant="h2"
        sx={styles.header}
        textAlign="center"
        component="div"
      >
        <strong>The Creator's Deal-Flow Kit</strong>
      </Typography>
      <Box sx={{ my: { xs: 2, md: 6 } }}>
        <StyledOrDivider text="What you'll get" />
      </Box>
      <strong>
        Bento's Monthly Pro + Partnership Data Bundle
        <br />
      </strong>
      <ul>
        <li>
          📧 1,000 verified brand emails every month - fresh, up-to-date, and
          ready to pitch.
        </li>
        <li>
          💸 Exclusive brand data so you know which brands are paying creators.
        </li>
        <li>
          🎯 Exclusive contact data so you're pitching the right person at the
          brand, every time.
        </li>
        <li>
          📲 Priority access to our new Instagram tagging feature (tag a creator
          on Instagram and get a full list of all brands they've partnered with,
          delivered to your dashboard within minutes!).
        </li>
      </ul>
      Perfect for creators who want to spend more time closing deals and less
      time digging through LinkedIn or Instagram.
      <Grid container justifyContent="center" sx={{ mt: 3, mb: 1 }}>
        <LoadingButton
          disableElevation
          variant="contained"
          onClick={clickGo}
          loading={fetchUserLoading}
        >
          {notQualified ? "Go to Dashboard" : "Claim offer"}
          <Box
            sx={{ ml: 1 }}
            component="i"
            className="fa-regular fa-arrow-right"
          />
        </LoadingButton>
      </Grid>
      <Grid container justifyContent="center">
        {notQualified ? (
          <FormHelperText sx={{ color: "secondary.dark" }}>
            <em>
              You have already subscribed to one or both of the items in the
              bundle.
            </em>
          </FormHelperText>
        ) : (
          <Chip
            size="small"
            sx={styles.limitedTime}
            label={
              <Box>
                <strong>
                  <em>20% off for the next 48 hours</em>
                </strong>
              </Box>
            }
          />
        )}
      </Grid>
      {isMobileScreen && (
        <Grid container justifyContent="center">
          <Box
            src={pic}
            component="img"
            sx={{ width: "100%", maxWidth: 350, mb: -10 }}
          />
        </Grid>
      )}
    </Box>
  );
};

export default ProgramInfo;
